import React from 'react';
import PropTypes from 'prop-types';

function FromTag(props) {
  const { text } = props;

  return <span className="sg">{text}</span>;
}
function ArticleSummery(props) {
  const {
    articlesummary: { title = '', excerpt = '', tag_list = [], created_time = '', updated_time = '', project_name = {}, project_type = {}, content_type = {} },
    onClick,
    type = 'default',
  } = props;
  switch (type) {
    case 'default':
      return (
        <div className="help_search_page_content_list" onClick={onClick}>
          <div className="content-name">
            <span dangerouslySetInnerHTML={{ __html: title }} />
            {tag_list.length > 0
              ? tag_list.map((v) => {
                return <FromTag key={v.tag_id} text={v.name} />;
              })
              : null}
          </div>
          <div className="sum" dangerouslySetInnerHTML={{ __html: excerpt }} />
          <div className="nums">
            <span> 创建时间：{created_time} </span>
            <span> 更新时间：{updated_time} </span>
          </div>
        </div>
      );
    case 'brandInvestment':
      return (
        <div className="help_search_page_content_list" onClick={onClick}>
          <div className="content-name">
            <span>{project_name.text}</span>
          </div>
          <div>
            <span> 项目类型：{project_type.text} </span>
            <span> 内容品类：{content_type.text} </span>
          </div>
          {/* <div className="nums">
            <span> 创建时间：{created_time} </span>
            <span> 更新时间：{updated_time} </span>
          </div> */}
        </div>
      );
    default:
      break;
  }
}
ArticleSummery.propTypes = {
  articlesummary: PropTypes.object,
  onClick: PropTypes.func,
};
export default ArticleSummery;
